import React, { useContext, useEffect, useState, Fragment } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { getScraperDetails, getStateDetails } from '../../api/GetScraperDetails';
import SwipeableViews from 'react-swipeable-views';
import ScraperOverTime from '../charts/ScraperOverTimeChart';
import GetGradientColor from '../../helpers/getGradientColor';
import { connect } from 'react-redux';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { actionCreators as historicalDataActionCreators } from '../../store/HistoricalData';
import { actionCreators as sdmActionCreators } from '../../store/ScraperDefinitionModels';
import { actionCreators as sourceDetailActionCreators } from '../../store/ScraperDetailStore';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Popper from '@material-ui/core/Popper';
import Grid from '@material-ui/core/Grid';
import Fade from '@material-ui/core/Fade';
import Typography from '@material-ui/core/Typography';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import UIContext from '../../contexts/uiContext'
import stateNames from '../../helpers/stateNames';
//import StateDetails from '../details/stateDetails';
import Link from '@material-ui/core/Link';
import progress from '../../styles/progress';
import { setSourceStatus } from '../../api/GetHistoricalData';

const useStyles = makeStyles(theme => ({
    typography: {
        padding: theme.spacing(2),
    },
    secondaryColor: {
        color: theme.palette.secondary.main
    }
}));

let ScraperByState = props => {
    const theme = useTheme();
    let otherClasses = useStyles();
    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    function cleanName(str) {
        //str = str.replace('City', '').replace('city', '');
        str = str.replace('ñ', 'n');
        if (str.indexOf(' (') !== -1)
            return str.substr(0, str.indexOf(' ('));
        if (str.indexOf(' |') !== -1)
            return str.substr(0, str.indexOf(' |'));
        return str;
    }

    let classes = progress();

    let privileged = props.advanced && sessionStorage.getItem('loggedIn') == 'true';
    let switchContainerClass = {
        justifyContent: 'flex-start',
        display: 'flex',
        flexWrap: 'wrap'
    };

    let userSettings = JSON.parse(localStorage.getItem("userSettings"));
    let fromDbSelectedFilter = userSettings['selectedFilter'];

    let [selectedFilter, setSelectedFilter] = React.useState(props.advanced && sessionStorage.getItem('loggedIn') == 'true' ? fromDbSelectedFilter : 'all');
    
    let [depth, setDepth] = useState(-1);

    let [combinedPopulationCoverage, setCombinedPopulationCoverage] = useState(0);
    let [combinedPopulationCoveragePercentage, setCombinedPopulationCoveragePercentage] = useState(0);

    let [courtPopulationCoverage, setCourtPopulationCoverage] = useState(0);
    let [courtPopulationCoveragePercentage, setCourtPopulationCoveragePercentage] = useState(0);

    let [arrestPopulationCoverage, setArrestPopulationCoverage] = useState(0);
    let [arrestPopulationCoveragePercentage, setArrestPopulationCoveragePercentage] = useState(0);

    let [populationCoverage, setPopulationCoverage] = useState(0);
    let [populationCoveragePercentage, setPopulationCoveragePercentage] = useState(0);
    let [statisticsTitle, setStatisticsTitle] = useState('United States');
    let [totalPopulation, setTotalPopulation] = useState(0);

    let [totalNumJurisdictions, setTotalNumJurisdictions] = useState(0);
    let [totalNumCoveredJurisdictions, setTotalNumCoveredJurisdictions] = useState(0);
    let [numCoveredJurisdictionsPercentage, setNumCoveredJurisdictionsPercentage] = useState(0);
    let [missingJurisdictions, setMissingJurisdictions] = useState([]);
    let [supportedJurisdictions, setSupportedJurisdictions] = useState([]);    
    let [supportedCourtTypes, setSupportedCourtTypes] = useState([]);    
    let [supportedSourcesLocation, setSupportedSourcesLocation] = useState('');    
    let supportedLocationIsState = supportedSourcesLocation.indexOf('-') == -1;
    let [currentState, setCurrentState] = useState(null);
    let [showProportionalToJurisdictions, setShowProportionalToJurisdictions] = useState(false);
    let [showProportionalToPopulation, setShowProportionalToPopulation] = useState(true);
    let [showSetupToSaveInHistoricalDB, setShowSetupToSaveInHistoricalDB] = useState(true);
    let onSwitchChange = (event) => {
        
        let id = (typeof (event) === 'string')
            ? event
            : event.target.id;
        setSelectedFilter(id);

        let userSettings = JSON.parse(localStorage.getItem("userSettings"));
        userSettings['selectedFilter'] = id;
        localStorage.setItem('userSettings', JSON.stringify(userSettings));

        renderMap(id);
    };

    let onShowProportionalToPopulationChange = (event) => {
        if (!showProportionalToPopulation) {
            setShowProportionalToJurisdictions(false);
            showProportionalToJurisdictions = false;
        }

        setShowProportionalToPopulation(!showProportionalToPopulation);
        showProportionalToPopulation = !showProportionalToPopulation;
        renderMap(selectedFilter);
    }

    let onShowProportionalToJurisdictionsChange = (event) => {
        if (!showProportionalToJurisdictions) {
            setShowProportionalToPopulation(false);
            showProportionalToPopulation = false;
        }

        setShowProportionalToJurisdictions(!showProportionalToJurisdictions);
        showProportionalToJurisdictions = !showProportionalToJurisdictions;
        
        renderMap(selectedFilter);
    }

    let onShowSetupToSaveInHistoricalDBChange = (event) => {
        setShowSetupToSaveInHistoricalDB(!showSetupToSaveInHistoricalDB);
        showSetupToSaveInHistoricalDB = !showSetupToSaveInHistoricalDB;
        renderMap(selectedFilter);
    }

    const context = useContext(UIContext);
    let ref = React.createRef();
    let stateOnClick = function (stateName) {
        let args = { ...props.sdms };
        Object.keys(args).forEach(function (key) { if (Array.isArray(args[key])) args[key] = args[key].filter(item => item.usaState == stateName); });
        window.numCourts = args.courts.length;
        window.numArrests = args.arrests.length;
        window.numRegistries = args.sexOffenderRegistries.length;

        let mapLink = `/map-usa/${stateName}`;
        let header = (<div>
            <div style={{ float: 'left' }}>
                {stateNames[stateName] || "Unknown State"}
            </div>
            {/*<div>
                <Button style={{ float: 'right', color: 'white' }} variant="contained" color="primary" className={classes.button} component={Link} to={mapLink}>
                    Go To Map
                </Button>
            </div>*/}
        </div>);

        context.setDetailHeader(header);
        //context.setDetailBody(<StateDetails {...props} {...args} />);
        if (window.elevation) context.openDetailPane(true);
    }

    let countyOnClick = async function (jurisdiction) {
        let args = { ...props.sdms, allNonSdms: [] };
        Object.keys(args).forEach(function (key) {
            if (Array.isArray(args[key])) args[key] = args[key].filter(item =>
                Object.keys(item.courtUidsBasedOnFips).map(k => k.toString()).filter(i => i == jurisdiction.fips.toString()).length != 0);
        });

        //let header = (<div>
        //    <div style={{ float: 'left' }}>
        //        {stateNames[jurisdiction.state]} - {jurisdiction.county}
        //    </div>
        //</div>);

        calculateSupportFunc(currentState.toUpperCase(), 'all', args, true);

        //context.setDetailHeader(header);
        ////context.setDetailBody(<StateDetails {...props} {...args} fips={jurisdiction.fips} />);
        //if (window.elevation) context.openDetailPane(true);
    }

    //let theColors = {
    //    fullSupport: '#2E7F18', // #45731E
    //    majoritySupport: '#45731E', // #675E24
    //    moderateSupport: '#675E24', //#8D472B
    //    limitedSupport: '#8D472B', //#B13433
    //    noSupport: '#B13433', //#C82538
    //}    


    let theColors = ['gray'];

    let alternativeNoSupportColor = '#0d47a1';
    if (window.elevation)
        theColors.push(alternativeNoSupportColor);
    
    let maxColorIndex = 50;
    for (let index = 1; index != maxColorIndex; ++index) {
        let theColor = GetGradientColor('#650f0f', '#FFFF00', index / (maxColorIndex - 1));

        theColors.push(theColor);
    }
    for (let index = 2; index != maxColorIndex; ++index) {
        theColors.push(GetGradientColor('#FFFF00', '#086508', index / (maxColorIndex - 1)));
    }


    //    '#FF0000', // <-- red
    //    '#FF1100',
    //    '#FF2200',
    //    '#FF3300',
    //    '#FF4400',
    //    '#FF5500',
    //    '#FF6600',
    //    '#FF7700',
    //    '#FF8800',
    //    '#FF9900',
    //    '#FFAA00',
    //    '#FFBB00',
    //    '#FFCC00',
    //    '#FFDD00',
    //    '#FFEE00',
    //    '#FFFF00',// <-- yellow
    //    '#EEFF00',
    //    '#DDFF00',
    //    '#CCFF00',
    //    '#BBFF00',
    //    '#AAFF00',
    //    '#99FF00',
    //    '#88FF00',
    //    '#77FF00',
    //    '#66FF00',
    //    '#55FF00',
    //    '#44FF00',
    //    '#33FF00',
    //    '#22FF00',
    //    '#11FF00',
    //    '#00FF00',// <-- green
    //];
    

    let renderState = (itemName, theSelectedFilter) => {
        supportedSourcesLocation = stateNames[(itemName || currentState).toUpperCase()];
        setSupportedSourcesLocation(supportedSourcesLocation)
        supportedLocationIsState = supportedSourcesLocation.indexOf('-') == -1;
        let stateMapId = 'usa_' + itemName;
        usaDrilldownConfig.shapes[0].options.name = stateMapId;
        // access state, then access county

        //props.requestStateDetail(itemName);

        let combinedPopulationSupported = 0;
        let combinedNumCoveredJurisdictions = 0;

        let courtPopulationSupported = 0;
        let courtNumCoveredJurisdictions = 0;

        let arrestPopulationSupported = 0;
        let arrestNumCoveredJurisdictions = 0;

        let populationSupported = 0;
        let statewidePopulation = 0;
        let totalNumCoveredJurisdictions = 0;

        let localMissingJurisdictions = [];
        let localSupportedJurisdictions = [];

        let objectOfCounties = {};
        let counties = window.zingchart.maps.data[stateMapId];
        let totalNoJurisdictions = 0;
        calculateSupportFunc(itemName.toUpperCase(), 'all', { ...props.sdms, allNonSdms: [] }, true);
        Object.entries(counties).filter(([key, value]) => {
            if (key.indexOf('_') == 0)
                return false;
            return true;
        }).forEach(([key, value]) => {
            totalNoJurisdictions += 1;  
            // calculate percentage supported

            let countyName = cleanName(counties[key].tooltip.text);

            let jurisdiction = props.jurisdictions.filter(j => j.state == itemName.toUpperCase() && j.county.toLowerCase().replace(/[\. ',:-]+/g, "").includes(countyName.toLowerCase().replace(/[\. ',:-]+/g, "")))[0];
            if (key == "SMI" && itemName == "tx")
                jurisdiction = props.jurisdictions.filter(j => j.state == itemName.toUpperCase() && j.county.toLowerCase().replace(/[\. ',:-]+/g, "").includes(countyName.toLowerCase().replace(/[\. ',:-]+/g, "")))[1];
            if (jurisdiction) {
                statewidePopulation = jurisdiction.statewidePopulation;
                let args = { ...props.sdms, allNonSdms: [] };
                Object.keys(args).forEach(function (key) {
                    if (Array.isArray(args[key])) args[key] = args[key].filter(item =>
                        Object.keys(item.courtUidsBasedOnFips).map(k => k.toString()).filter(i => i == jurisdiction.fips.toString()).length != 0);
                });
                let support = calculateSupportFunc(itemName.toUpperCase(), theSelectedFilter, args);


                //var isSedgwick = itemName == 'ks' && (countyName.indexOf('Sedgwick') != -1);
                //if (isSedgwick && theSelectedFilter == 'courts') {
                //    support = '#FFFF00';
                //}
                //else if (isSedgwick && (theSelectedFilter == 'arrests' || theSelectedFilter == 'all')) {
                //    support = '#086508';
                //}

                var isIlCook = itemName == 'il' && (countyName.indexOf('Cook') != -1);
                if (isIlCook && theSelectedFilter == 'courts') {
                    support = '#FFFF00';
                }
                else if (isIlCook && (theSelectedFilter == 'arrests' || theSelectedFilter == 'all')) {
                    support = '#086508';
                }
                    

                if (!(support == 'gray' || support == alternativeNoSupportColor)) {
                    populationSupported += jurisdiction.jurisdictionPopulation;
                    totalNumCoveredJurisdictions += 1;
                    localSupportedJurisdictions.push([countyName, jurisdiction.jurisdictionPopulation]);
                } else {
                    localMissingJurisdictions.push([countyName, jurisdiction.jurisdictionPopulation]);
                }
                objectOfCounties[key] = { 'background-color': support };


                let combinedSupport = calculateSupportFunc(itemName.toUpperCase(), 'all', args);

                if (!(combinedSupport == 'gray' || combinedSupport == alternativeNoSupportColor)) {
                    combinedPopulationSupported += jurisdiction.jurisdictionPopulation;
                    combinedNumCoveredJurisdictions += 1
                } else {

                }

                let courtSupport = calculateSupportFunc(itemName.toUpperCase(), 'courts', args);

                if (!(courtSupport == 'gray' || courtSupport == alternativeNoSupportColor)) {
                    if (!isIlCook) {
                        courtPopulationSupported += jurisdiction.jurisdictionPopulation;
                        courtNumCoveredJurisdictions += 1
                    }
                } else {

                }

                let arrestSupport = calculateSupportFunc(itemName.toUpperCase(), 'arrests', args);

                if (!(arrestSupport == 'gray' || arrestSupport == alternativeNoSupportColor)) {
                    arrestPopulationSupported += jurisdiction.jurisdictionPopulation;
                    arrestNumCoveredJurisdictions += 1
                } else {

                }

                //if (isSedgwick)
                //    counties[key].tooltip.text = `Sedgwick | Court Support Limited To Wichita City`;
                //if (isIlCook)
                //    counties[key].tooltip.text = `Cook | Partial Court Support`;
            }
            else {
                if (countyName == "Golden Valley" && (theSelectedFilter == 'courts' || theSelectedFilter == 'all')) {
                    localSupportedJurisdictions.push(['Golden Valley', 1]);
                    objectOfCounties[key] = { 'background-color': '#086508' };
                } else if (countyName == "Golden Valley" && (theSelectedFilter == 'arrests')) {
                    localMissingJurisdictions.push(['Golden Valley', 1]);
                    objectOfCounties[key] = { 'background-color': 'gray' };
                } else if (itemName == 'sd' && countyName == "Shannon" && (theSelectedFilter == 'courts' || theSelectedFilter == 'all')) {
                    localSupportedJurisdictions.push(['Shannon', 8189]);
                    objectOfCounties[key] = { 'background-color': '#086508' };
                }
                else if (itemName == 'sd' && countyName == "Shannon" && (theSelectedFilter == 'arrests')) {
                    localSupportedJurisdictions.push(['Shannon', 8189]);
                    objectOfCounties[key] = { 'background-color': '#808080' };
                }
                else {
                    //localMissingJurisdictions.push([countyName, -1]);
                    //objectOfCounties[key] = { 'background-color': '#086508' };
                }
            }
        });



        let numCoveredJurisdictions = ((theSelectedFilter == 'courts' || theSelectedFilter == 'all') && (itemName == 'sd' || itemName == "nd" || itemName == "hi")) ? totalNoJurisdictions : totalNumCoveredJurisdictions; // 

        setTotalNumJurisdictions(totalNoJurisdictions);
        setTotalNumCoveredJurisdictions(numCoveredJurisdictions);
        //setNumCoveredJurisdictionsPercentage(Math.floor((totalNumCoveredJurisdictions / totalNoJurisdictions) * 100));
        let totalJurisdictionCoveredPercentage = parseFloat(Math.round((numCoveredJurisdictions / totalNoJurisdictions) * 10000) / 100);
        setNumCoveredJurisdictionsPercentage(totalJurisdictionCoveredPercentage);

        //let courtJurisdictionCoveredPercentage = parseFloat(Math.round((courtNumCoveredJurisdictions / totalNoJurisdictions) * 10000) / 100);
        //setNumCoveredJurisdictionsPercentage(courtJurisdictionCoveredPercentage);        

        let oneHundredPercentCoverage = totalJurisdictionCoveredPercentage.toString() == "100" || itemName == 'il' || itemName == 'sd' || itemName == "nd" || itemName == "hi" || itemName == "nc" || itemName == 'va' || itemName == 'ks' || itemName == 'co';

        setStatisticsTitle(stateNames[itemName.toUpperCase()]);
        setTotalPopulation(statewidePopulation);

        setCombinedPopulationCoverage(oneHundredPercentCoverage ? statewidePopulation : combinedPopulationSupported);
        setCombinedPopulationCoveragePercentage(oneHundredPercentCoverage ? 100 : parseFloat(Math.round((combinedPopulationSupported / statewidePopulation) * 10000) / 100));

        //setPopulationCoverage(oneHundredPercentCoverage ? statewidePopulation : populationSupported);
        //setPopulationCoveragePercentage(oneHundredPercentCoverage ? 100 : parseFloat(Math.round((populationSupported / statewidePopulation) * 10000) / 100));

        setCourtPopulationCoverage(itemName == 'ks' || itemName == 'mo' || itemName == 'md' || itemName == 'ia' || itemName == 'co' || itemName == 'sd' || itemName == 'nd' || itemName == 'hi' || itemName == 'va' || itemName == 'nc' ? statewidePopulation : courtPopulationSupported);
        setCourtPopulationCoveragePercentage(itemName == 'ks' || itemName == 'mo' || itemName == 'md' || itemName == 'ia' || itemName == 'co' || itemName == 'sd' || itemName == 'nd' || itemName == 'hi' || itemName == 'va' || itemName == 'nc' ? 100 : parseFloat(Math.round((courtPopulationSupported / statewidePopulation) * 10000) / 100));

        //if (itemName == 'ks') {
        //    setCourtPopulationCoverage(2397898); // population minus sedgwick, since we only cover Wichita
        //    setCourtPopulationCoveragePercentage(parseFloat(Math.round((2397898 / statewidePopulation) * 10000) / 100)); // population minus sedgwick, since we only cover Wichita
        //}

        //if (itemName == 'il') {
        //    setCourtPopulationCoverage(7566130); // population minus cook, since we only partially cover Cook
        //    setCourtPopulationCoveragePercentage(parseFloat(Math.round((7566130 / statewidePopulation) * 10000) / 100)); // population minus cook, since we only partiall cover Cook
        //}

        setArrestPopulationCoverage(false ? statewidePopulation : arrestPopulationSupported);
        setArrestPopulationCoveragePercentage(false ? 100 : parseFloat(Math.round((arrestPopulationSupported / statewidePopulation) * 10000) / 100));

        setMissingJurisdictions(localMissingJurisdictions);
        setSupportedJurisdictions(localSupportedJurisdictions);
        
        // populate right side


        usaDrilldownConfig.shapes[0].options.style.items = objectOfCounties;

        // load right-side pane
        stateOnClick(itemName.toUpperCase());

        setTimeout(function () { // makes the ui less jittery after enlarging a state
            window.zingchart.exec('usaChart', 'setdata', {
                data: usaDrilldownConfig
            });
        }, 0);
    }

    //drilldown chart configuration
    let usaDrilldownConfig = {
        gui: {
            contextMenu: {
                button: {
                    visible: false
                }
            },
            gear: {
                type: 'hamburger',
                backgroundColor: 'transparent'
            }
        },
        shapes: [
            { //Drilldown maps.
                type: 'zingchart.maps',
                options: {
                    name: 'state',

                    zooming: false,
                    panning: false,
                    scrolling: false,

                    style: {
                        controls: {
                            visible: false
                        },
                        cursor: 'pointer',
                        backgroundColor: 'pink',
                        hoverState: {
                            alpha: 0.3,
                            backgroundColor: 'white',
                        },
                        tooltip: {
                            alpha: 0.8,
                            backgroundColor: 'white',
                            borderColor: 'white',
                            borderRadius: 3,
                            fontColor: 'black',
                            fontFamily: 'Georgia',
                            fontSize: 12,
                            textAlpha: 1
                        }
                    }
                }
            },
            { //Button to go back to main map.
                id: 'back_button',
                type: 'rectangle',
                height: 25,
                width: 40,
                x: 20,
                y: 20,

                backgroundColor: '#C4C4C4',
                borderRadius: 3,
                cursor: 'hand',
                //fontColor: 'white',
                hoverState: {
                    alpha: 0.3,
                    backgroundColor: 'white'
                },
                label: {
                    text: 'Back',
                }
            }
        ]
    };

    // used in the shape_click event to determine if we should drilldown
    function hasStateDrilldownData(stateMapId) {
        let drillDownCountries = listOfStates.map(function (curVal) {
            return 'usa_' + curVal;
        });
        for (let i = 0; i < drillDownCountries.length; i++) {
            if (stateMapId === drillDownCountries[i])
                return true;
        }

        return false;
    }

    function hasCountyDrilldownData() {
        return true;
    }

    let styles = {
        filterBar: {
            //width: "80%",
            marginLeft: "1em",
            marginRight: "1em",
            paddingLeft: "1em",
            paddingRight: "1em",
            marginBottom: "1em"
        },
        formGroup: {
            justifyContent: "center",
            display: 'grid'
        }
    };

    let sourceTypeMap = {
        '10': 'County Court',
        '11': 'Circuit Court',
        '12': 'Common Pleas Court',
        '13': 'General District Court',
        '14': 'Municipal Court',
        '15': 'Mayor\'s Court',
        '16': 'Justice of the Peace',
        '17': 'Family Court',
        '18': 'Probate Court',
        '19': 'General Civil Court',
        '20': 'Small Claims Court',
        '21': 'City Court',
        '22': 'Statewide Court',
        '23': 'District Court',
        '24': 'Village Court',
        '25': 'General Sessions',
        '26': 'Superior Court',
        '27': 'Town Court',
        '28': 'Magistrate Court',
        '29': 'Other',
        '30': 'Criminal Court',
        '31': 'Housing Court',
        '32': 'Community Court',
        '33': 'Tribal Court',
        '34': 'State Court',
        '35': 'Traffic Court',
        '36': 'Metro Court',
        '37': 'County Court at Law',
        '38': 'Justice Court',
        '39': 'Trial Court',
        '40': 'Constitutional Court',
        //'41': 'Prefile',
        '42': 'Judicial Bureau',
        '43': 'Violations Bureau',
        '49': 'Other',
        '50': 'Arrest',
        '51': 'Warrant / Most Wanted',
        //'52': 'Department Of Corrections',
        //'53': 'Sex Offender Registry',
        '54': 'Jail Booking',
        '59': 'Other',
        //'60': 'Bar Organization',
        '69': 'Other',
        '75': 'Arrest',
        //'89': 'Other', //  (AL Use)
        '92': 'Texas Conviction Database',
        //'99': 'National Booking Source',
    };

    let listOfStates = ["al", "ak", "az", "ar", "ca", "co", "ct", "de", "dc", "fl", "ga", "hi", "id", "il", "in", "ia", "ks", "ky", "la", "me", "md", "ma", "mi", "mn", "ms", "mo", "mt", "ne", "nv", "nh", "nj", "nm", "ny", "nc", "nd", "oh", "ok", "or", "pa", "ri", "sc", "sd", "tn", "tx", "ut", "vt", "va", "wa", "wv", "wi", "wy"];
    let digitAtPos = function (number, pos)
    {
        return Math.round(Math.trunc((number / Math.pow(10.0, pos - 1) )) % 10);
    }
    let calculateSupportFunc = (stateName, theSelectedFilter, data, computeCourtTypes) => {
        let stateJurisdictions = props.jurisdictions.filter(j => j.state == stateName.toUpperCase());
        let theData = data || props.sdms;
        let supportedList = [];
        let notSupportedList = [];


        if (theSelectedFilter === 'caseTracking') {
            supportedList = theData.withCaseTracking;
            notSupportedList = theData.withoutCaseTracking;
            
        }
        else if (theSelectedFilter === 'monitoring') {
            supportedList = theData.withMonitoring;
            notSupportedList = theData.withoutMonitoring;
            
        }
        else if (theSelectedFilter === 'nameSearch') {
            supportedList = theData.withNameSearch;
            notSupportedList = theData.withoutNameSearch;
            
        }
        else if (theSelectedFilter === 'saveToDB') {
            supportedList = theData.withSaveToDB;
            notSupportedList = theData.withoutSaveToDB;
            
        }
        else if (theSelectedFilter === 'courts') {
            supportedList = theData.courts;
            notSupportedList = [];
        }
        else if (theSelectedFilter === 'sexOffenderRegistries') {
            supportedList = theData.sexOffenderRegistries;
            notSupportedList = [];
        }
        else if (theSelectedFilter === 'arrests') {
            supportedList = theData.arrests;
            notSupportedList = [];
        }
        else if (theSelectedFilter === 'all') {
            supportedList = theData.all;
            notSupportedList = [];
        }

        supportedList = supportedList.filter(item => item.usaState == stateName);
        notSupportedList = notSupportedList.filter(item => item.usaState == stateName);

        if (depth == 0 && theSelectedFilter === 'courts') {
            supportedList = supportedList.filter(item => !(item.usaState == 'IL' && item.scraperName == 'Cook County Circuit Court'));
            //supportedList = supportedList.filter(item => !(item.usaState == 'KS' && item.scraperName == 'Wichita Municipal Court'));
        }

        if (depth == 1 && computeCourtTypes && props.advanced && sessionStorage.getItem('loggedIn') == 'true' /*&& !Array.isArray(supportedCourtTypes)*/) {

            //if (supportedLocationIsState && stateName == 'NC')
            //    setSupportedCourtTypes([sourceTypeMap['50'], sourceTypeMap['26'] + ' | 100% state pop. covered', sourceTypeMap['23'] + ' | 100% state pop. covered', sourceTypeMap['53']]);
            //else
                if (supportedLocationIsState && stateName == 'VA')
                    setSupportedCourtTypes([sourceTypeMap['50'] + ' | Not Calculated', sourceTypeMap['11'] + ' | 100% state pop. covered', sourceTypeMap['13'] + ' | 100% state pop. covered', /*sourceTypeMap['53'] + ' | 100% state pop. covered'*/]);
            else if (supportedLocationIsState && stateName == 'MD')
                    setSupportedCourtTypes([sourceTypeMap['50'] + ' | Not Calculated', sourceTypeMap['11'] + ' | 100% state pop. covered', sourceTypeMap['13'] + ' | 100% state pop. covered', /*sourceTypeMap['53'] + ' | 100% state pop. covered'*/]);
            else if (supportedLocationIsState &&  stateName == 'VT')
                    setSupportedCourtTypes([sourceTypeMap['42'] + ' | 100% state pop. covered', /*sourceTypeMap['53'] + ' | 100% state pop. covered'*/]);
            else if (supportedLocationIsState &&  stateName == 'ME')
                    setSupportedCourtTypes([sourceTypeMap['43'] + ' | 100% state pop. covered', sourceTypeMap['50'] + ' | Not Calculated', /*sourceTypeMap['53'] + ' | 100% state pop. covered'*/]);
            else {
                supportedList.filter(s => s.setupToSaveInHistoricalDB ).forEach(x => {                        

                    var ossidCourtUidMap = x.courtUidsBasedOnFips;
                    for (const prop in ossidCourtUidMap) {

                        if (stateName == 'VA' && x.scraperName == "Circuit Court") {
                            if (supportedCourtTypes.filter(x => x.indexOf('Circuit Court') != -1).length == 0)
                                supportedCourtTypes.push(sourceTypeMap['11'] + ' | 100% state pop. covered');
                            continue;
                        }
                        else if (stateName == 'VA' && x.scraperName == "General Court") {
                            if (supportedCourtTypes.filter(x => x.indexOf('General District Court') != -1).length == 0)
                                supportedCourtTypes.push(sourceTypeMap['13'] + ' | 100% state pop. covered');
                            continue;
                        }
                        else if (stateName == 'NC') {
                            if (supportedCourtTypes.filter(x => x.indexOf('Arrest') != -1).length == 0)
                                supportedCourtTypes.push(sourceTypeMap['50'] + ' | Not Calculated')
                            if (supportedCourtTypes.filter(x => x.indexOf('Superior Court') != -1).length == 0)
                                supportedCourtTypes.push(sourceTypeMap['26'] + ' | 100% state pop. covered')
                            if (supportedCourtTypes.filter(x => x.indexOf('District Court') != -1).length == 0)
                                supportedCourtTypes.push(sourceTypeMap['23'] + ' | 100% state pop. covered')
                            continue;
                        }

                        let ossIds = ossidCourtUidMap[prop]
                        ossIds.forEach(oid => {
                            if (oid.toString().length != 9 && x.usaState != "CA" && x.usaState != "AL" && x.usaState != "AR" && x.usaState != "CO") {
                                console.log('not length 9');
                            }

                            let firstDigit = digitAtPos(oid, 4);
                            let secondDigit = digitAtPos(oid, 3);
                            let combination = firstDigit.toString() + secondDigit.toString();

                            var sourceType = sourceTypeMap[combination];
                            if (!sourceType)
                                ;
                            if (sourceType != undefined && supportedCourtTypes.filter(x => x.indexOf(sourceType) != -1).length == 0) {
                                let uniqueFips = {};
                                var supportedPopulation = supportedList.reduce(function (accum, current) { if (current.isStateWide) return accum; Object.keys(current.courtUidsBasedOnFips).forEach((c) => { if (!uniqueFips[c] && current.courtUidsBasedOnFips[c].filter(x => (digitAtPos(x, 4).toString() + digitAtPos(x, 3).toString()) == combination).length > 0) { let jurisdictions = stateJurisdictions.filter(sj => sj.fips == c); accum += jurisdictions.length ? jurisdictions[0].jurisdictionPopulation : 0; uniqueFips[c] = true; } }); return accum; }, 0);
                                if (stateJurisdictions[0].statewidePopulation) {
                                    if (supportedPopulation > (stateJurisdictions[0].statewidePopulation * 1.2))
                                        supportedPopulation -= stateJurisdictions[0].statewidePopulation;
                                }

                                supportedCourtTypes.push(sourceType + ` | ${parseFloat(Math.round((supportedPopulation / stateJurisdictions[0].statewidePopulation * 10000) / 100))}% state pop. covered`)
                            }
                                
                        })

                    }
                });

                //for (let i = supportedCourtTypes.length; i != -1; --i) {
                //    if (supportedCourtTypes[i].indexOf(' 0%'))
                //}
                
                setSupportedCourtTypes(supportedCourtTypes);
                return;
            }
        }
        //else setSupportedCourtTypes([]);
        


        if (depth <= 0 && (stateName == 'ME') && theSelectedFilter == 'courts')
            return "#FFFF00";

        if (depth <= 0 && (stateName == 'VT') && theSelectedFilter != 'arrests')
            return "#FFFF00";
        else if (depth <= 0 && (stateName == 'VT') && theSelectedFilter == 'arrests')
            return '#808080';
        if ((theSelectedFilter == 'courts' || theSelectedFilter == 'all') && (stateName == 'VA' || stateName == 'ND' || stateName == 'SD' || stateName == 'HI' || stateName == 'NC'))
            return theColors[theColors.length - 1];

        if (depth <= 0 && theSelectedFilter == 'arrests' && (stateName == 'VA'))
            return '#8a490b';


        if (supportedList.length === 0 && notSupportedList.filter(s => s.dataSourceType != 'sexOffenderRegistry').length > 0) {
            return theColors[1];//'darkblue';//theColors[1];
        }



        if (theSelectedFilter == 'courts') {

        }

        let fraction = -1;

        if ((showSetupToSaveInHistoricalDB || showProportionalToJurisdictions || showProportionalToPopulation)/* && (theSelectedFilter == 'courts' || theSelectedFilter == 'arrests' || theSelectedFilter == 'sexOffenderRegistries' || theSelectedFilter === 'all')*/) {
            if (showSetupToSaveInHistoricalDB)
                supportedList = supportedList.filter(s => s.setupToSaveInHistoricalDB );
            if (showProportionalToJurisdictions && theSelectedFilter != 'sexOffenderRegistries') {
                let supportedLength = supportedList.reduce(function (accum, current) { Object.keys(current.courtUidsBasedOnFips).forEach(c => accum.push(c)); return accum; }, []).length;
                if (depth <= 0)
                    fraction = supportedLength / props.jurisdictions.filter(j => j.state == stateName.toUpperCase()).length;
                //else if (depth == 1)
                //    fraction = supportedLength / 1;
            }
            else if (showProportionalToPopulation) {
                if (depth <= 0) {
                    if (stateJurisdictions.length === 0) {
                        fraction = 0;
                    }
                    else {
                        supportedList = supportedList.filter(l => l.dataSourceType !== "SexOffenderRegistry" && l.dataSourceType !== "DepartmentOfCorrections");
                        let uniqueFips = {};
                        var supportedPopulation = supportedList.reduce(function (accum, current) { if (current.isStateWide) return accum; Object.keys(current.courtUidsBasedOnFips).forEach(c => { if (!uniqueFips[c]) { let jurisdictions = stateJurisdictions.filter(sj => sj.fips == c); accum += jurisdictions.length ? jurisdictions[0].jurisdictionPopulation : 0; uniqueFips[c] = true; } }); return accum; }, 0);
                        if (stateJurisdictions[0].statewidePopulation) {
                            if (supportedPopulation > (stateJurisdictions[0].statewidePopulation * 1.2))
                                supportedPopulation -= stateJurisdictions[0].statewidePopulation;
                            fraction = supportedPopulation / stateJurisdictions[0].statewidePopulation;
                        }
                            
                        else fraction = 0;
                    }
                }
            }
        }


        let denominator = (supportedList.length + notSupportedList.length) || 1;
        if (fraction == -1)
            fraction = supportedList.length / denominator;

        let index = fraction > 0 && (fraction < (1 / theColors.length)) ? Math.ceil(fraction * theColors.length) :
            fraction < 1 && (fraction > (theColors.length - 1 / theColors.length))
                ? Math.floor(fraction * theColors.length)
                : Math.floor(fraction * theColors.length);
        if (index < 0 || !index)
            index = 0;
        if (index > (theColors.length - 1))
            index = theColors.length - 1;

        if (index == 0 && depth == 1 && (stateName == 'VT' || stateName == 'ME') && theSelectedFilter != 'arrests')
            return "#FFFF00";

        return theColors[index];
    }

    let renderMap = (theSelectedFilter, itemName) => {
        let zingchart = window.zingchart;

        if (depth == 1)
        {
            renderState(itemName || currentState, theSelectedFilter);
        }
        else if (depth <= 0) {
            renderUsa(theSelectedFilter);    
        }


        var c2 = document.getElementById("legendCanvas2");
        let noCoverageLabel = document.getElementById('noCoverageLabel');
        if (c2) {
            if (depth == 0) {
                c2.style.display = 'initial';
                let ctx = c2.getContext("2d");
                let grd = ctx.createLinearGradient(0, 0, 250, 0);

                grd.addColorStop(0, "gray");
                grd.addColorStop(1, "gray");

                noCoverageLabel.style.display = 'block';
                noCoverageLabel.innerText = "No Support";

                ctx.fillStyle = grd;
                ctx.fillRect(0, 0, 250, 100);
            }
            else {
                c2.style.display = 'none';
                noCoverageLabel.style.display = 'none';
            }
        }

        var c = document.getElementById("legendCanvas");
        if (c) {
            let ctx = c.getContext("2d");
            let grd = ctx.createLinearGradient(0, 0, 250, 0);

            document.getElementById('middleCoverageLabel').innerText = "";
            if (depth == 1 && (
                theSelectedFilter == 'courts'
                || theSelectedFilter == 'arrests'
                || theSelectedFilter == 'sexOffenderRegistries'
                || theSelectedFilter == 'all')) {
                var theState = (itemName || currentState);
                if (theState == 'me' || theState == 'vt') {
                    //grd.addColorStop(0, "gray");
                    //grd.addColorStop(.32, "gray");
                    grd.addColorStop(0, "#FFFF00");
                    grd.addColorStop(.49, "#FFFF00");
                    grd.addColorStop(.5, "#086508");
                    grd.addColorStop(1, "#086508");

                    document.getElementById('lessCoverageLabel').innerText = "Traffic Courts";
                    document.getElementById('moreCoverageLabel').innerText = "Traffic Courts + Arrests";
                }
                else {
                    grd.addColorStop(0, "gray");
                    grd.addColorStop(.49, "gray");
                    grd.addColorStop(.50, "#086508");
                    grd.addColorStop(1, "#086508");

                    document.getElementById('lessCoverageLabel').innerText = "No Support";
                    document.getElementById('moreCoverageLabel').innerText = "Partial/Full Support";
                }
            }
            else {
                grd.addColorStop(0, "#650f0f");
                grd.addColorStop(.49, "#FFFF00");
                grd.addColorStop(.50, "#FFFF00");
                grd.addColorStop(1, "#086508");

                document.getElementById('lessCoverageLabel').innerText = "Less Support";
                document.getElementById('moreCoverageLabel').innerText = "More Support";

                //grd.addColorStop(0, "gray");
                //grd.addColorStop(.14, "gray");
                //grd.addColorStop(.16, "#650f0f");
                //grd.addColorStop(.55, "#FFFF00");
                //grd.addColorStop(.56, "#FFFF00");
                //grd.addColorStop(1, "#086508");

                //document.getElementById('lessCoverageLabel').innerText = "No Support";
                //document.getElementById('middleCoverageLabel').innerText = "Less Support";
                //document.getElementById('moreCoverageLabel').innerText = "More Support";
            }

            ctx.fillStyle = grd;
            ctx.fillRect(0, 0, 250, 100);
        }
    }

    let renderUsa = (theSelectedFilter) => {
        let objectOfStates = {};
        for (let i = 0; i < listOfStates.length; i++) {
            let itemId = listOfStates[i].toUpperCase();

            let support = calculateSupportFunc(itemId, theSelectedFilter);            

            objectOfStates[itemId] = {
                //'background-color': itemId == 'OR' || itemId == 'ID' || itemId == 'UT' || itemId == 'HI' ? '#086508' :
                //    itemId == 'TX' ? '#71A704' : support,
                'background-color': support
            }
        }

        let nationwidePopulation = 327171000;
        let localMissingJurisdictions = [];
        let localSupportedJurisdictions = [];
        let totalNoJurisdictions = 3143;


        let cacheKey = theSelectedFilter;

        //remove old cached values
        localStorage.removeItem("precomputedArgs");
        localStorage.removeItem("precomputedArgs1");
        localStorage.removeItem("precomputedArgs2");
        localStorage.removeItem("precomputedArgs3");
        localStorage.removeItem("precomputedArgs4");
        localStorage.removeItem("precomputedArgs5");
        localStorage.removeItem("precomputedArgs6");
        localStorage.removeItem("precomputedArgs7");
        localStorage.removeItem("precomputedArgs8");
        localStorage.removeItem("precomputedArgs9");
        let precomputeKey = "precomputedArgs10";
        window.auxCache = window.auxCache || {};
        window.precomputedArgs = localStorage.getItem(precomputeKey) && JSON.parse(localStorage.getItem(precomputeKey)) || {};

        
        if (!window.precomputedArgs[cacheKey]) {
            window.precomputedArgs[cacheKey] = true;

            let globalArrestPopulationSupported = 0; //globalArrestPopulationSupported || 0;
            let globalCombinedPopulationSupported = 0; //globalCombinedPopulationSupported || 0;
            let globalCourtPopulationSupported = 0; //globalCourtPopulationSupported || 0;
            let globalTotalNumCoveredJurisdictions = 0; //globalTotalNumCoveredJurisdictions || 0;
            let globalMissingJurisdictions = [];
            let globalSupportedJurisdictions = [];

            let theJurisdictions = [...new Map(props.jurisdictions.map(jurisdiction => [jurisdiction.state + jurisdiction.county, jurisdiction])).values()];
            theJurisdictions.forEach((jurisdiction) => {
                //totalNoJurisdictions += 1;
                // calculate percentage supported
                let itemName = jurisdiction.state;
                let countyName = jurisdiction.county;
                //let jurisdiction = props.jurisdictions.filter(j => listOfStates.indexOf(x => x == j.state) != -1  && j.county.toLowerCase().replace(/[\. ',:-]+/g, "").includes(countyName.toLowerCase().replace(/[\. ',:-]+/g, "")))[0];
                if (!jurisdiction.isStateWide && jurisdiction.county.toLowerCase() != 'all' && jurisdiction.county.toLowerCase() != 'statewide' && jurisdiction.county.toLowerCase() != 'nation wide' && jurisdiction.county.toLowerCase() != 'all superior courts') {
                    //nationwidePopulation = jurisdiction.nationwidePopulation;
                    let args = { ...props.sdms, allNonSdms: [] };

                    if (window.auxCache[`${itemName}${countyName}`]) {
                        args = window.auxCache[`${itemName}${countyName}`];
                    }
                    else {
                        Object.keys(args).forEach(function (key) {
                            if (Array.isArray(args[key])) args[key] = args[key].filter(item =>
                                Object.keys(item.courtUidsBasedOnFips).map(k => k.toString()).filter(i => i == jurisdiction.fips.toString()).length != 0);
                        });
                        window.auxCache[`${itemName}${countyName}`] = args;
                    }

                    let support = 'gray';
                    var isIlCook = itemName == 'IL' && (jurisdiction.county.indexOf('Cook') != -1);
                    //var isSedgwick = itemName == 'KS' && (jurisdiction.county.indexOf('Sedgwick') != -1);

                    if (window.precomputedArgs[`${itemName}${countyName}${theSelectedFilter}`])
                        support = window.precomputedArgs[`${itemName}${countyName}${theSelectedFilter}`];
                    else {
                        support = calculateSupportFunc(itemName.toUpperCase(), theSelectedFilter, args);


                        
                        //if (isSedgwick && theSelectedFilter == 'courts') {
                        //    support = 'gray';
                        //}
                        //else if (isSedgwick && (theSelectedFilter == 'arrests' || theSelectedFilter == 'all')) {
                        //    support = '#086508';
                        //}

                        
                        if (isIlCook && theSelectedFilter == 'courts') {
                            support = 'gray';
                        }
                        else if (isIlCook && (theSelectedFilter == 'arrests' || theSelectedFilter == 'all')) {
                            support = '#086508';
                        }

                        window.precomputedArgs[`${itemName}${countyName}${theSelectedFilter}`] = support;
                    }

                  

                    if (!(support == 'gray' || support == alternativeNoSupportColor)) {
                        globalTotalNumCoveredJurisdictions += 1;
                        localSupportedJurisdictions.push([countyName, jurisdiction.jurisdictionPopulation, itemName]);
                    } else {
                        localMissingJurisdictions.push([countyName, jurisdiction.jurisdictionPopulation, itemName]);
                    }
                    //objectOfCounties[key] = { 'background-color': support };


                    let combinedSupport = calculateSupportFunc(itemName.toUpperCase(), 'all', args);

                    if (!(combinedSupport == 'gray' || combinedSupport == alternativeNoSupportColor)) {
                        globalCombinedPopulationSupported += jurisdiction.jurisdictionPopulation;
                        //globalCombinedNumCoveredJurisdictions += 1
                    } else {

                    }

                    let courtSupport = calculateSupportFunc(itemName.toUpperCase(), 'courts', args);

                    if (isIlCook) {
                        courtSupport = 'gray';
                    }

                    if (!(courtSupport == 'gray' || courtSupport == alternativeNoSupportColor)) {
                        globalCourtPopulationSupported += jurisdiction.jurisdictionPopulation;
                        //globalCourtNumCoveredJurisdictions += 1
                    } else {

                    }

                    let arrestSupport = calculateSupportFunc(itemName.toUpperCase(), 'arrests', args);

                    if (!(arrestSupport == 'gray' || arrestSupport == alternativeNoSupportColor)) {
                        globalArrestPopulationSupported += jurisdiction.jurisdictionPopulation;
                        //globalArrestNumCoveredJurisdictions += 1
                    } else {

                    }

                }
                else {
                    if (countyName == "Golden Valley" && (theSelectedFilter == 'courts' || theSelectedFilter == 'all')) {
                        localSupportedJurisdictions.push(['Golden Valley', 1, 'ND']);
                        //objectOfCounties[key] = { 'background-color': '#086508' };
                    } else if (countyName == "Golden Valley" && (theSelectedFilter == 'arrests')) {
                        localMissingJurisdictions.push(['Golden Valley', 1, 'ND']);
                        //objectOfCounties[key] = { 'background-color': 'gray' };
                    } else if (itemName == 'sd' && countyName == "Shannon" && (theSelectedFilter == 'courts' || theSelectedFilter == 'all')) {
                        localSupportedJurisdictions.push(['Shannon', 8189, 'SD']);
                        //objectOfCounties[key] = { 'background-color': '#086508' };
                    }
                    else {
                        //localMissingJurisdictions.push([countyName, -1]);
                        //objectOfCounties[key] = { 'background-color': '#086508' };
                    }
                }
            });

            window.precomputedArgs[cacheKey + "globalArrestPopulationSupported"] = globalArrestPopulationSupported;
            window.precomputedArgs[cacheKey + "globalCombinedPopulationSupported"] = globalCombinedPopulationSupported;
            window.precomputedArgs[cacheKey + "globalCourtPopulationSupported"] = globalCourtPopulationSupported;
            window.precomputedArgs[cacheKey + "globalTotalNumCoveredJurisdictions"] = globalTotalNumCoveredJurisdictions;
            window.precomputedArgs[cacheKey + "globalMissingJurisdictions"] = globalMissingJurisdictions;
            window.precomputedArgs[cacheKey + "globalSupportedJurisdictions"] = globalSupportedJurisdictions;
        }       

        localStorage.setItem(precomputeKey, JSON.stringify(window.precomputedArgs));

        setTotalNumJurisdictions(totalNoJurisdictions);
        setTotalNumCoveredJurisdictions(window.precomputedArgs[cacheKey + "globalTotalNumCoveredJurisdictions"]);
        //setNumCoveredJurisdictionsPercentage(Math.floor((window.precomputedArgs[cacheKey + "globalTotalNumCoveredJurisdictions"] / totalNoJurisdictions) * 100));
        let totalJurisdictionCoveredPercentage = parseFloat(Math.round((window.precomputedArgs[cacheKey + "globalTotalNumCoveredJurisdictions"] / totalNoJurisdictions) * 10000) / 100);
        setNumCoveredJurisdictionsPercentage(totalJurisdictionCoveredPercentage);

        //let courtJurisdictionCoveredPercentage = parseFloat(Math.round((globalCourtNumCoveredJurisdictions / totalNoJurisdictions) * 10000) / 100);
        //setNumCoveredJurisdictionsPercentage(courtJurisdictionCoveredPercentage);        

        //let oneHundredPercentCoverage = totalJurisdictionCoveredPercentage.toString() == "100" || itemName == "nd" || itemName == "hi" || itemName == "nc" || itemName == 'va';

        setStatisticsTitle("United States");
        setTotalPopulation(nationwidePopulation);

        var numSupported = window.precomputedArgs[cacheKey + "globalCombinedPopulationSupported"] - 626299 - 783348 - 982000; // vermont maine populationadjustment
        setCombinedPopulationCoverage(numSupported); 
        setCombinedPopulationCoveragePercentage(parseFloat(Math.round((numSupported / nationwidePopulation) * 10000) / 100));

        //setPopulationCoverage(oneHundredPercentCoverage ? nationwidePopulation : populationSupported);
        //setPopulationCoveragePercentage(oneHundredPercentCoverage ? 100 : parseFloat(Math.round((populationSupported / nationwidePopulation) * 10000) / 100));

        var courtSupported = window.precomputedArgs[cacheKey + "globalCourtPopulationSupported"] - 626299 - 1338404 - 939000; // vermont maine populationadjustment
        setCourtPopulationCoverage(courtSupported); 
        setCourtPopulationCoveragePercentage(parseFloat(Math.round((courtSupported / nationwidePopulation) * 10000) / 100));
        

        setArrestPopulationCoverage(false ? nationwidePopulation : window.precomputedArgs[cacheKey + "globalArrestPopulationSupported"]);
        setArrestPopulationCoveragePercentage(false ? 100 : parseFloat(Math.round((window.precomputedArgs[cacheKey + "globalArrestPopulationSupported"] / nationwidePopulation) * 10000) / 100));

        setMissingJurisdictions(window.precomputedArgs[cacheKey + "globalMissingJurisdictions"]);
        setSupportedJurisdictions(window.precomputedArgs[cacheKey + "globalSupportedJurisdictions"]);

        let usaConfig = {
            gui: {
                contextMenu: {
                    button: {
                        visible: false
                    }
                },
                gear: {
                    type: 'hamburger',
                    backgroundColor: 'transparent'
                }
            },
            shapes: [
                {
                    type: 'zingchart.maps',
                    options: {
                        name: 'usa',

                        zooming: false,
                        panning: false,
                        scrolling: false,

                        style: {
                            backgroundColor: '#fafafa',
                            controls: {
                                visible: false
                            },
                            fillType: 'radial',
                            cursor: 'pointer',
                            hoverState: {
                                alpha: 0.3,
                                backgroundColor: 'white',
                            },
                            items: objectOfStates, //include specific shape regions with unique styles
                            tooltip: {
                                alpha: 0.8,
                                backgroundColor: 'white',
                                borderColor: 'white',
                                borderRadius: 3,
                                fontColor: 'black',
                                fontFamily: 'Georgia',
                                fontSize: 12,
                                textAlpha: 1
                            }
                        }
                    }
                }
            ]
        };
        /* 
             *  need this function to render the first map load with random colors
             */
        // set boolean that we are looking at the usa county, not individual state
        window.zingchart.render({
            id: 'usaChart',
            data: usaConfig,
            height: '100%',
            width: '100%'
        });

        depth = 0; // i know this seems wrong, but don't remove this line. this variable is captured by closure in the rebindChart below.
        rebindChart();
    };

    let rebindChart = () => {
        let zingchart = window.zingchart;
        /*
             * shape click is when we render a new chart or load the original chart
             */
        zingchart.unbind('usaChart', 'shape_click');
        zingchart.bind('usaChart', 'shape_click', e => {
            let itemName = String(e.shapeid).toLowerCase();

            let shapeId = e.shapeid;

            // if shape is our back button and not the map
            if (shapeId == 'back_button') {
                setDepth(0);
                depth = 0;
                if (showMissingOpen)
                    handleShowMissing();
                if (showSupportedOpen)
                    handleShowSupported();
                setStatisticsTitle('United States');
                context.setPageTitle(!window.elevation && 'Court & Arrest Coverage' || "USA Map");
                // since we are using setdata, reload will reload the original chartJSON

                //zingchart.exec('usaChart', 'reload');
                renderMap(selectedFilter);
                return;
            }

            if (depth == 0) { // navigate to state
                supportedCourtTypes = [];
                setSupportedCourtTypes([]);
                let stateMapId = 'usa_' + itemName;
                context.setPageTitle(`${stateNames[itemName.toUpperCase()] || 'Unknown'} Coverage`);
                if (hasStateDrilldownData(stateMapId)) {
                    setDepth(1);
                    depth = 1;
                    setCurrentState(itemName);

                    renderMap(selectedFilter, itemName);
                }
            }
            else if (depth == 1) { // navigate to county
                let stateMapId = 'usa_' + currentState;
                let countyName = cleanName(window.zingchart.maps.data[stateMapId][itemName.toUpperCase()].tooltip.text);
                
                let selectedJurisdiction = props.jurisdictions.filter(j => j.state == currentState.toUpperCase() && j.county.toLowerCase().replace(/[\. ',:-]+/g, "").includes(countyName.toLowerCase().replace(/[\. ',:-]+/g, "")))[0];

                supportedCourtTypes = [];
                let newLocation = stateNames[currentState.toUpperCase()] + ' - ' + countyName;
                setSupportedSourcesLocation(newLocation)
                supportedSourcesLocation = newLocation;
                supportedLocationIsState = supportedSourcesLocation.indexOf('-') == -1;
                countyOnClick(selectedJurisdiction);
            }
        });
    };
    rebindChart();

    if (depth < 0 ) {
        if (props.sdms.all.length > 0) {
            renderMap(selectedFilter);
            setDepth(0);
            depth = 0;
        }
    }

    const [showMissingAnchorEl, setShowMissingAnchorEl] = React.useState(null);
    let handleShowMissing = (event) => {
        setShowMissingAnchorEl(showMissingAnchorEl ? null : event.currentTarget);
        if (showSupportedOpen)
            handleShowSupported();
    }

    let showMissingOpen = Boolean(showMissingAnchorEl);
    const showMissingId = showMissingOpen ? 'show-missing-popper' : undefined;

    const [showSupportedAnchorEl, setShowSupportedAnchorEl] = React.useState(null);
    let handleShowSupported = (event) => {
        setShowSupportedAnchorEl(showSupportedAnchorEl ? null : event.currentTarget);
        if (showMissingOpen)
            handleShowMissing();
    }

    let showSupportedOpen = Boolean(showSupportedAnchorEl);
    const showSupportedId = showSupportedOpen ? 'show-missing-popper' : undefined;

    const [stateDataIndex, setStateDataIndex] = React.useState(0);

    function handleStateDataChange(event, newValue) {
        setStateDataIndex(newValue);
    }

    function handleStateDataIndexChange(index) {
        setStateDataIndex(index);
    }

    useEffect(() => {
        //props.requestSdms();

        let zingchart = window.zingchart;
        // must load maps and first map we are going to render
        zingchart.loadModules('maps,maps-usa');

        //renderMap();

        // stringify the maps to load them into page using loadModules()
        let stringifyMapList = listOfStates.reduce(function (acc, curVal, index) {
            if (index === 1)
                acc = 'maps-usa_' + acc;
            return acc + ',' + 'maps-usa_' + curVal;
        });

        // for maps that exist in our library. Pre-load them later on
        //zingchart.loadModules(stringifyMapList);        

        try {
            if (props.sdms.all.length > 0) {
                renderMap(selectedFilter);
                setDepth(0);
                depth = 0;
            }
            //else
            //    setTimeout(function () {
            //        renderMap(selectedFilter);
            //        setDepth(0);
            //        depth = 0;
            //    }, 3000);
        }
        catch(ex) {

        }
    }, []);

    
    return (
        <div style={{ textAlign: "center", width: "100%" }}>
            <Grid key={0} className="outer-map-wrapper" >
                {(window.elevation || privileged) && (<Grid key={1} item xs={2} style={{paddingLeft:'1em', width: 250, display: 'inline-table'}}>
                    {window.elevation && (<Fragment><div style={{ fontWeight: 'bold', paddingTop: 5, textAlign: 'left' }}>
                        <span title='(Of What We Have, How Much Do We Support)'>Feature Support</span>
                    </div>
                        <hr />
                        
                    <FormGroup row style={styles.formGroup}>
                            {/*<FormControlLabel
                        control={
                            <Switch id="automatedTest" checked={selectedFilter == "automatedTest"} onChange={onSwitchChange} />
                        }
                        label="Automated Test"
                    />*/}
                        
                            <div style={switchContainerClass}>
                                <FormControlLabel
                                    control={
                                        <Switch id="caseTracking" checked={selectedFilter == "caseTracking"} onChange={onSwitchChange} color="primary" />
                                    }
                                    label="Case Tracking"
                                />
                                <FormControlLabel
                                    control={
                                        <Switch id="monitoring" checked={selectedFilter == "monitoring"} onChange={onSwitchChange} color="primary" />
                                    }
                                    label="Monitoring"
                                />
                                <FormControlLabel
                                    control={
                                        <Switch id="nameSearch" checked={selectedFilter == "nameSearch"} onChange={onSwitchChange} color="primary" />
                                    }
                                    label="Name Search"
                                />
                                <FormControlLabel
                                    control={
                                        <Switch id="saveToDB" checked={selectedFilter == "saveToDB"} onChange={onSwitchChange} color="primary" />
                                    }
                                    label="Saves To Database"
                                />
                            </div>
                        </FormGroup>
                    </Fragment>
                    )}
                    {/*<Paper style={styles.filterBar}>
                        <div style={{ fontWeight: 'bold', paddingTop: 5 }}>
                            Order Progress
                            </div>
                        <hr />
                        <div style={switchContainerClass}>
                            <FormGroup row style={styles.formGroup}>
                                <FormControlLabel
                                    control={
                                        <Switch id="caseTrackingProgress" checked={selectedFilter == "caseTrackingProgress"} onChange={onSwitchChange} />
                                    }
                                    label="Case Tracking"
                                />
                            </FormGroup>
                        </div>
                    </Paper>*/}

                        <div style={{ fontWeight: 'bold', paddingTop: 5, textAlign: 'left' }}>
                         <span>Data Sources</span>
                        </div>
                        <hr />
                        <FormGroup row style={styles.formGroup}>
                            <div style={switchContainerClass}>
                                <FormControlLabel
                                    control={
                                    <Switch id="courts" checked={selectedFilter == "courts"} onChange={onSwitchChange} color="primary" />
                                    }
                                    label="Courts"
                                />
                                <FormControlLabel
                                    control={
                                    <Switch id="arrests" checked={selectedFilter == "arrests"} onChange={onSwitchChange} color="primary" />
                                    }
                                    label="Arrests"
                                />
                                {!privileged && depth == 0 && (
                                    <FormControlLabel
                                        control={
                                        <Switch id="sexOffenderRegistries" checked={selectedFilter == "sexOffenderRegistries"} onChange={onSwitchChange} color="primary" />
                                        }
                                        label="S.O.R."
                                    />
                                )}
                                <FormControlLabel
                                    control={
                                    <Switch id="all" checked={selectedFilter == "all"} onChange={onSwitchChange} color="primary" />
                                    }
                                    label="Combined"
                                />
                            </div>
                        </FormGroup>
                    {depth == 0 && false && (
                        <Fragment>
                            <div style={{ fontWeight: 'bold', paddingTop: 5, textAlign: 'left' }}>
                                <span>Adjust Parameters</span>
                            </div>
                            <hr />
                            <FormGroup row style={styles.formGroup}>
                                <div style={switchContainerClass}>
                                    <Fragment>
                                        <FormControlLabel
                                            control={
                                                <Switch id="jurisdictions" checked={showProportionalToJurisdictions} onChange={onShowProportionalToJurisdictionsChange} color="primary" />
                                            }
                                            label="Jurisdiction"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Switch id="population" checked={showProportionalToPopulation} onChange={onShowProportionalToPopulationChange} color="primary" />
                                            }
                                            label="Population"
                                        />
                                    </Fragment>
                                </div>
                            </FormGroup>
                            </Fragment>
                    )}
                    {depth == 1 && supportedJurisdictions && supportedJurisdictions.length > 0 && (
                        <Fragment>
                            <br/>
                            {(window.elevation || privileged) && (<Fragment><Button aria-describedby={showSupportedId} variant="contained" onClick={handleShowSupported}>
                                See Supported
                            </Button><br />
                                <Popper id={showSupportedId} open={showSupportedOpen} anchorEl={showSupportedAnchorEl} transition
                                    modifiers={{
                                        flip: {
                                            enabled: false,
                                        },
                                        preventOverflow: {
                                            enabled: true,
                                            boundariesElement: 'undefined',
                                        },

                                    }}
                                >
                                    {({ TransitionProps }) => (
                                        <Fade {...TransitionProps} timeout={350}>
                                            <Paper style={{ padding: '1em', maxHeight: '60vh', overflow: 'overlay' }}>
                                                <Typography component="h1" variant="h6" color="inherit" noWrap>
                                                    Supported Jurisdictions
                                            </Typography>
                                                <hr />
                                                {supportedJurisdictions.sort((a, b) => b[0] - a[0]).map(j => <Typography key={j[0]} className={otherClasses.typography}>{`${(depth == 0 ? (j[2] + ' - ') : '')}${j[0]}`}</Typography>)/* (pop. ${numberWithCommas(j[1])})*/}
                                            </Paper>
                                        </Fade>
                                    )}
                                </Popper></Fragment>)}
                            <br/>
                        </Fragment>
                    )}
                    {depth == 1 && missingJurisdictions && missingJurisdictions.length > 0 && (
                        <Fragment>
                            {(window.elevation || privileged) && (<Fragment><Button aria-describedby={showMissingId} variant="contained" onClick={handleShowMissing}>
                                See Missing
                            </Button><br />
                                <Popper id={showMissingId} open={showMissingOpen} anchorEl={showMissingAnchorEl} transition
                                    modifiers={{
                                        flip: {
                                            enabled: false,
                                        },
                                        preventOverflow: {
                                            enabled: true,
                                            boundariesElement: 'undefined',
                                        },

                                    }}
                                >
                                    {({ TransitionProps }) => (
                                        <Fade {...TransitionProps} timeout={350}>
                                            <Paper style={{ padding: '1em', maxHeight: '60vh', overflow: 'overlay' }}>
                                                <Typography component="h1" variant="h6" color="inherit" noWrap>
                                                    Missing Jurisdictions
                                            </Typography>
                                                <hr />
                                                {missingJurisdictions.sort((a, b) => b[0] - a[0]).map(j => <Typography key={j[0]} className={otherClasses.typography}>{`${(depth == 0 ? (j[2] + ' - ') : '')}${j[0]}`}</Typography>/* (pop. ${numberWithCommas(j[1])})*/)}
                                            </Paper>
                                        </Fade>
                                    )}
                                </Popper></Fragment>)}
                        </Fragment>
                    )}
                    {depth == 1 && false && props.advanced && supportedCourtTypes && (
                        <Fragment>
                            <br />
                            <div style={{ fontWeight: 'bold', paddingTop: 5, textAlign: 'left' }}>
                                <span>Available Sources</span> {/*(privileged) && (<Fragment><Button style={{float:'right', marginTop: '-1em'}} variant="contained" onClick={() => renderState(currentState, selectedFilter)} disabled={supportedLocationIsState}>Back To State</Button></Fragment>)*/}
                            </div>
                            <hr />
                            <Typography component="h1" variant="h6" color="inherit" noWrap style={{textAlign: 'left'}}>
                                 {supportedSourcesLocation}
                            </Typography>
                            {supportedCourtTypes.sort((a, b) => (a > b ? 1 : -1)).map(sct => <div style={{ textAlign: 'left' }}>{sct.split('|')[0].trim()} <small style={{fontSize: 11.5, float:'right', marginTop: 2}}>{sct.split('|')[1].trim()}</small></div>)}
                            {(supportedCourtTypes.length == 0 ? <div style={{ textAlign: 'left' }}>N/A</div> : '')}
                        </Fragment>
                    )}
                    {window.elevation && (<Fragment>
                        <div style={{ fontWeight: 'bold', paddingTop: 5, textAlign: 'left' }}>
                        <span>Misc</span>
                        </div>
                        <hr/>
                        <div style={switchContainerClass}>
                        <FormGroup row style={styles.formGroup}>

                            <FormControlLabel
                                control={
                                    <Switch id="historicalDB" checked={showSetupToSaveInHistoricalDB} onChange={onShowSetupToSaveInHistoricalDBChange} color="primary" />
                                }
                                label="S2DB Configured For ATServer2"
                            />
                        </FormGroup>
                        </div>
                    </Fragment>)}
                    {window.elevation && (
                        <Fragment><div style={{ fontWeight: 'bold', paddingTop: 5, textAlign: 'left' }}>
                            <span>Legend</span>
                            {/*<span className={otherClasses.secondaryColor} style={{ float: 'right' }}>hide</span>*/}
                        </div>
                            <hr />
                            <canvas id="legendCanvas" width={(window.elevation ? "250" : "350")} height={(window.elevation ? "100" : "200")} style={{ marginTop: '1em' }} />
                            <br />
                            <span id='lessCoverageLabel' style={{ float: 'left' }}></span> <span id='middleCoverageLabel' style={{ marginLeft: '1em' }} ></span> <span id='moreCoverageLabel' style={{ float: 'right' }}></span>
                        </Fragment>)}
                </Grid>)}
                <Grid key={2} className="inner-map-wrapper" item xs={9}>
                    <Paper style={styles.filterBar}><div id="usaChart" ref={ref} ></div>
                    </Paper>
                </Grid>
                <Grid key={3} item xs={3} style={{ maxWidth: '280px', marginLeft: 'auto', marginRight: 'auto', marginTop:'-20px' }}>
                    {!statisticsTitle && (
                            window.elevation2 && (
                                <Fragment>
                                {/*<Paper style={{ paddingTop: 9, paddingBottom: 9, marginBottom: '1em', marginTop: '10px' }}>
                                        <div style={{ fontWeight: 'bold', marginBottom: 7, fontSize: 17 }}>
                                        Unsupported Courts/Arrests
                                    </div>
                                        <div style={{ fontSize: 16, marginBottom: 5 }}>
                                            Delaware
                                    </div>
                                </Paper>*/}
                                {/*<Paper style={{ paddingTop: 9, paddingBottom: 9, marginBottom: '1em' }}>
                                    <div style={{ fontWeight: 'bold', marginBottom: 7, fontSize: 17 }}>
                                        Unsupported Courts
                                    </div>
                                    <div style={{ fontSize: 16, marginBottom: 5 }}>
                                        Louisiana <div style={{ marginBottom: '5px'}}></div>
                                        Mississippi <div style={{ marginBottom: '5px'}}></div>
                                        Montana <div style={{ marginBottom: '5px'}}></div>
                                        New Hampshire <div style={{ marginBottom: '5px'}}></div>
                                        South Dakota <div style={{ marginBottom: '5px'}}></div>
                                        Wyoming <div style={{ marginBottom: '5px'}}></div>
                                    </div>
                                </Paper>*/}
                                {/*<Paper style={{ paddingTop: 9, paddingBottom: 9, marginBottom: '1em' }}>
                                <div style={{ fontWeight: 'bold', marginBottom: 7, fontSize: 17 }}>
                                    Traffic Court Support Only 
                                    </div>
                                <div style={{ fontSize: 16, marginBottom: 5 }}>
                                    Maine <div style={{ marginBottom: '5px' }}></div>
                                    Vermont <div style={{ marginBottom: '5px' }}></div>
                                    </div>
                                </Paper>*/}
                            </Fragment>
                            )
                        
                        )}
                    {(true || statisticsTitle) && (
                        <Fragment>
                            <div>
                                <Typography variant="h6" style={{ paddingBottom: 9, fontSize: 36, marginLeft: 10, display: 'inline-block', marginBottom: -10, paddingTop: 9,  display: 'table', marginLeft: 'auto', marginRight: 'auto' }}>
                                    {statisticsTitle}
                                </Typography>                                
                            </div>
                            <Paper style={{paddingTop: 9, paddingBottom: 9, marginBottom: '1em'}}>
                                <b style={{ fontSize: 38 }}>{combinedPopulationCoveragePercentage}%</b>
                                <div style={{ fontWeight: 'bold', marginBottom: 7, fontSize: 17 }}>
                                Combined Coverage
                            </div>
                            <div style={{ fontSize: 16, marginBottom: 5 }}>
                                    {numberWithCommas(combinedPopulationCoverage)} / {numberWithCommas(totalPopulation)} people
                            </div>
                            </Paper>
                            {window.elevation2 && courtPopulationCoverage > 0 && (
                                <Fragment>
                                    <Paper style={{ paddingTop: 9, paddingBottom: 9, marginBottom: '1em' }}>
                                        <b style={{ fontSize: 38 }}>{courtPopulationCoveragePercentage}%</b>
                                    <div style={{ fontWeight: 'bold', marginBottom: 7, fontSize: 17 }}>
                                            {(depth == 1 && (currentState == 'me' || currentState == 'vt') ? 'Traffic ' : '')}Court Coverage
                                    </div>
                                    <div style={{ fontSize: 16, marginBottom: 5 }}>
                                        {numberWithCommas(courtPopulationCoverage)} / {numberWithCommas(totalPopulation)} people
                                    </div>
                                    </Paper>
                                    </Fragment>
                            )}
                            {false && privileged && arrestPopulationCoverage > 0 && (
                                <Fragment>
                                    <Paper style={{ paddingTop: 9, paddingBottom: 9, marginBottom: '1em' }}>
                                        <b style={{ fontSize: 38 }}>{arrestPopulationCoveragePercentage}%</b>
                                        <div style={{ fontWeight: 'bold', marginBottom: 7, fontSize: 17 }}>
                                            Arrest Coverage
                                    </div>
                                        <div style={{ fontSize: 16, marginBottom: 5 }}>
                                            {numberWithCommas(arrestPopulationCoverage)} / {numberWithCommas(totalPopulation)} people
                                    </div>
                                    </Paper>
                                </Fragment>
                            )}
                            {depth == 1 && privileged && (
                                <Fragment>
                                    <Paper style={{ paddingTop: 9, paddingBottom: 9, marginBottom: '1em' }}>
                                        <b style={{ fontSize: 38 }}>{numCoveredJurisdictionsPercentage}%</b>
                                        <div style={{ fontWeight: 'bold', marginBottom: 7, fontSize: 17 }}>
                                            {(selectedFilter == 'all' ? <span>Combined </span> : selectedFilter == 'courts' ? <span>Court </span> : <span>Arrest </span>)}Jurisdiction Coverage
                        </div>
                                        <div style={{ fontSize: 16, marginBottom: 5 }}>
                                            {totalNumCoveredJurisdictions} / <span>{totalNumJurisdictions}</span> jurisdictions
                            </div>
                                    </Paper>
                                </Fragment>)}
                        </Fragment>
                    )}
                    {depth == 1 && (
                        <Fragment>
                            {!window.elevation && (<Fragment><Paper style={{ paddingTop: 10, paddingBottom: 10 }}>
                                {(window.numCourts > 0 ? <span style={{ display: 'inline-block' }}><b>Includes</b> {(currentState == 'me' || currentState == 'vt' ? 'Traffic ' : '')}Courts</span> : '')} {(window.numArrests > 0 ? <span>{(window.numCourts > 0 ? <span>|</span> : '')} <span style={{ display: 'inline-block' }}><b>Includes</b> Arrests</span></span> : '')} {(window.numRegistries > 0 ? <br /> : '')}<span style={{ display: 'inline-block' }}>{(window.numRegistries > 0 ? <span> <b>Includes</b> Statewide Sex Offender Registry</span> : "")}</span>
                            </Paper>
                                </Fragment>)}
                            {/*<Paper>
                                <AppBar position="static" color="default">
                                    <Tabs
                                        value={stateDataIndex}
                                        onChange={handleStateDataChange}
                                        indicatorColor="primary"
                                        textColor="primary"
                                        variant="fullWidth"
                                    >
                                        <Tab style={{ fontWeight: 'bold' }} label={`All Monthly Data`} />
                                        {window.elevation && (<Tab style={{ fontWeight: 'bold' }} label={`Monthly Arrests`} />)}
                                        {window.elevation && (<Tab style={{ fontWeight: 'bold' }} label={`Monthly Courts`} />)}
                                    </Tabs>
                                </AppBar>
                                <SwipeableViews
                                    axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                                    index={stateDataIndex}
                                    onChangeIndex={handleStateDataIndexChange}
                                    className={classes.swipeableViewsRoot}
                                >
                                    <div>
                                        <div style={{ textAlign: 'center', paddingBottom: 12, marginTop: '4px' }}>
                                            <span><span className={classes.label}><b>{numberWithCommas(props.stateDateTimeDataPoints.reduce((acc, cur) => acc + cur.count, 0))}</b></span> Records</span> &nbsp;&nbsp;&nbsp;&nbsp;
                                        </div>
                                        <ScraperOverTime data={props.stateDateTimeDataPoints} />
                                    </div>
                                    {window.elevation && (<div>
                                        <div style={{ textAlign: 'center', paddingBottom: 12, marginTop: '4px' }}>
                                            <span><span className={classes.label}># of Records</span>: {numberWithCommas(props.stateDateTimeDataPointsArrests.reduce((acc, cur) => acc + cur.count, 0))}</span> &nbsp;&nbsp;
                                            <span><span className={classes.label}># of Cases</span>: {numberWithCommas(props.stateDateTimeDataPointsArrests.reduce((acc, cur) => acc + cur.caseCount, 0))}</span> &nbsp;&nbsp;
                                        </div>
                                        <ScraperOverTime data={props.stateDateTimeDataPointsArrests} />
                                    </div>)}
                                    {window.elevation && (<div>
                                        <div style={{ textAlign: 'center', paddingBottom: 12, marginTop: '4px' }}>
                                            <span><span className={classes.label}># of Records</span>: {numberWithCommas(props.stateDateTimeDataPointsCourts.reduce((acc, cur) => acc + cur.count, 0))}</span> &nbsp;&nbsp;
                                            <span><span className={classes.label}># of Cases</span>: {numberWithCommas(props.stateDateTimeDataPointsCourts.reduce((acc, cur) => acc + cur.caseCount, 0))}</span> &nbsp;&nbsp;
                                        </div>
                                        <ScraperOverTime data={props.stateDateTimeDataPointsCourts} />
                                    </div>)}
                                </SwipeableViews>
                                

                                
                            </Paper>*/}
                        </Fragment>
                    )}
                    {!window.elevation && (
                        <Fragment>
                            <div style={{ fontWeight: 'bold', textAlign: 'center' }}>
                                <Typography variant="h6" style={{ marginLeft: 10, display: 'inline-block', paddingTop: 9, display: 'table', marginLeft: 'auto', marginRight: 'auto' }}>
                                    Legend
                                </Typography>
                            {/*<span className={otherClasses.secondaryColor} style={{ float: 'right' }}>hide</span>*/}
                        </div>
                            <canvas id="legendCanvas" width="250" height="50" style={{ marginTop: '1em' }} />
                            <br />
                            <span id='lessCoverageLabel' style={{ float: 'left' }}></span> <span id='middleCoverageLabel' style={{ marginLeft: '1em' }} ></span> <span id='moreCoverageLabel' style={{ float: 'right' }}></span>
                            <canvas id="legendCanvas2" width="250" height="50" style={{ marginTop: '1em' }} />
                            <span id='noCoverageLabel' style={{ display:'block' }}></span> 
                                <br />
                                <br />
                        </Fragment>)}
                </Grid>
            </Grid>
        </div>
    );
}

export default connect(state => {
    return {
        isLoading: state.historicalData.isLoading,
        historicalData: state.historicalData.historicalData,
        //sdms: state.scraperDefinitionModels,
        ...state.scraperDetail
    };
},
    {
        //requestSdms: sdmActionCreators.requestSdms,
        ...sourceDetailActionCreators
    })(ScraperByState);